import { useEffect } from "react";

const RightClickProtection = () => {
  useEffect(() => {
    const preventRightClickOnImages = (e) => {
      const target = e.target;

      // Block right-click on <img> tags
      if (target.tagName === "IMG") {
        e.preventDefault();
      }

      // Optional: block right-click on anything with a background-image
      const style = window.getComputedStyle(target);
      const bgImage = style.getPropertyValue("background-image");
      if (bgImage && bgImage !== "none") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", preventRightClickOnImages);
    return () => {
      document.removeEventListener("contextmenu", preventRightClickOnImages);
    };
  }, []);

  return null;
};

export default RightClickProtection;
